import React from "react";

import "react-toastify/dist/ReactToastify.css";
import { Alert, Button, Card, Container, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import {
  ALUMNO_REGULAR,
  DEACARGAR_CERTIFICADO_ALUMNO_REGULAR,
} from "../helpers/endpoints";
import { useState, useEffect } from "react";
import { helpHttp } from "../helpers/helpAxios";
import { setMessageAction } from "../actions/messageActions";
import {
  BsExclamationTriangle,
  BsFillFileEarmarkPdfFill,
} from "react-icons/bs";
import { axiosDownloadFile } from "../helpers/axiosDownloadFile";
import AvisoGestionMaterias from "./utils/AvisoGestionMaterias";

export default function Home() {
  const dispatch = useDispatch();
  const carreraSect = useSelector((state) => state.carr.carreraSect);
  const [isRegular, setIsRegular] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [isMostrarMensaje, setIsMostrarMensaje] = useState(false);

  const mensajeSistema = (message, tipo) => {
    dispatch(
      setMessageAction({
        type: tipo,
        mensaje: message
          ? message
          : "Es este momento no podemos procesar la solicitud. Intente mas tarde",
      }),
    );
  };

  const getIsRegular = () => {
    helpHttp()
      .get(ALUMNO_REGULAR + "/" + carreraSect?.alumnoPrograma)
      .then((response) => {
        setIsRegular(response.data);
        setIsDisable(false);
      })
      .catch((error) => {
        mensajeSistema(error.message, "error");
      });
  };

  useEffect(() => {
    carreraSect?.alumnoPrograma && getIsRegular();
  }, [carreraSect?.alumnoPrograma]);

  const pdf = () => {
    if (isRegular) {
      setIsMostrarMensaje(false);
      axiosDownloadFile(
        DEACARGAR_CERTIFICADO_ALUMNO_REGULAR +
          "/" +
          carreraSect?.alumnoPrograma,
        "certificado",
      );
      // deshabilitar button durante 5 segundos
      setIsDisable(true);
      setTimeout(() => {
        setIsDisable(false);
      }, 15000);
    } else {
      setIsMostrarMensaje(true);
    }
  };
  return (
    <>
      <Container>
        <Row id="certifcadoAlumnoRegular" className="mt-5">
          <Col md={12} lg={4}>
            <Card
              className="shadow p-3"
              style={{ transition: "transform 0.2s" }}
            >
              <Card.Body>
                <Button
                  className="bt btn-info mb-2"
                  style={{ textAlign: "left", fontWeight: "bold" }}
                  onClick={() => {
                    //setIsDisable(true); // Disable the button while axiosDownloadFile executes
                    pdf();
                    //setIsDisable(false); // Re-enable the button after execution
                  }}
                  disabled={isDisable}
                >
                  {<BsFillFileEarmarkPdfFill />} Descargar certificado de Alumno
                  Regular
                </Button>

                {isMostrarMensaje && (
                  <Card.Text>
                    <>
                      <Alert key={"warning"} variant={"warning"}>
                        {<BsExclamationTriangle />}
                        <br />
                        Usted no es alumno regular. <br />
                        Por favor comunicarse con el departamento de alumnos
                      </Alert>
                    </>
                  </Card.Text>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col md={12} lg={8}>
            <Card
              className="shadow p-3"
              style={{ transition: "transform 0.2s" }}
            >
              <Card.Body>
                <AvisoGestionMaterias />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
